import { render } from "./PrizesList.vue?vue&type=template&id=1c055e39&scoped=true"
import script from "./PrizesList.vue?vue&type=script&lang=js"
export * from "./PrizesList.vue?vue&type=script&lang=js"

import "./PrizesList.vue?vue&type=style&index=0&id=1c055e39&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c055e39"]])

export default __exports__